import texts from './navbar.texts'

class NavbarController {
    constructor($scope, $state, User, Category) {
        this.name = 'navbar'

        this.$scope = $scope
        this.$state = $state
        this.User = User
        this.Category = Category

        this.burgerMenuRotated = false
    }

    $onInit() {
        // Set active language on page load
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        // Render texts
        this.render()

        // Set user if logged in
        this.setActiveUser()

        // Watch user authentication status change
        this.watchUser()
    }

    render() {
        const {
            NAVIGATIONS,
            MY_BOOK,
            LOG_OUT
        } = texts[this.language]

        this.navigations = NAVIGATIONS
        this.myBook = MY_BOOK
        this.logoutText = LOG_OUT
    }

    clearCategories() {
        this.Category.clearSelectedCategories()

        this.$state.go('home', {
            search: ''
        })
    }

    changeLanguage(language) {
        this.language = language

        localStorage.setItem('tourists_lang', language)

        this.render()
    }

    setActiveUser() {
        this.User.getCurrentUser()
            .then((user) => {
                this.user = user
            })
            .catch(() => {
                this.user = null
            })
    }

    watchUser() {
        this.$scope.$watch(() => this.User.getUser(), (newValue) => {
            this.user = newValue
        })
    }

    goToMyBook() {
        const bookId = localStorage.getItem('tourists_bookId')

        this.$state.go('home.book.bookStep3', {
            bookId
        }, {
            reload: true
        })
    }

    logout() {
        this.User.logout()
    }

    toggleBurgerMenu() {
        this.burgerMenuRotated = !this.burgerMenuRotated
        $('.burger-menu').slideToggle()
    }
}

NavbarController.$inject = ['$scope', '$state', 'User', 'Category']

export default NavbarController



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js